.mvFooter {
    border-top: 1px solid #ebefef;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.mvFooterLeft,
.mvFooterRight {
    width: auto;
    display: flex;
    align-items: center;
    padding: 1rem;

    @media screen and (min-width: 768px) {
        width: 50%;
    }
}

.mvFooterLeft {
    justify-content: space-between;
}

.mvFooterRight {
    justify-content: flex-end;
}

.mvFooterTotal {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.mvCancelButton {
    margin-right: 0.5em;
}

.mvFooterTotalLabel {
    color: rgba(0, 0, 0, 0.5);
    font-size: 0.875rem;
    margin-bottom: 0.1rem;
}

.mvFooterTotalCount {
    font-size: 1.5rem;
    font-weight: 600;
    color: #14456b;
}
